import { ModuleProps, CreateModuleProps } from "components";
import { Routes } from "./Routes";
import { Dashboard } from "./Dashboard";
import { Rights } from "./Rights";

export const Module: ModuleProps = CreateModuleProps({
    id: "COMPENSATION",
    applicationRights: Rights,
    title: 'Tillegg<span id=\'MenuItemDescriptionCompensation\'></span>',
    text: 'Tillegg',
    icon: 'hand-coins',
    showOnDashboardByDefault: false,
    url: "/pilot/compensation",
    mobileThreshold: 1024,
    sequenceNo: 6000,
    routes: Routes,
    dashboard: Dashboard
})
